
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { ImportSetAdminState } from './types-store';
import { reducer as importSetAdminFormReducer, INITIAL_STATE as importSetAdminFormState } from './form/reducers';
import { reducer as importSetsAdminListReducer, INITIAL_STATE as importSetsAdminListState } from './list/reducers';

export const INITIAL_STATE: ImportSetAdminState = {
  form: importSetAdminFormState,
  list: importSetsAdminListState
};

export const reducer: Reducer<ImportSetAdminState> = withOptionsReducer(
  STATE.importSetAdministration,
  mergeReducers({
    form: importSetAdminFormReducer,
    list: importSetsAdminListReducer
  })
);
